import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { FaTimes } from 'react-icons/fa';
import { TextField } from '@mui/material';
import {
  FormContainer,
  FormHeader,
  FormTitle,
  CloseButton,
  Form,
  FormGroup
} from './styles';

const DashboardForm = forwardRef(({ 
  mode = 'add', 
  dashboard = null, 
  projectId, 
  onSubmit, 
  onCancel,
  onValidityChange 
}, ref) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    code: '',
  });

  useEffect(() => {
    if (mode === 'edit' && dashboard) {
      const newData = {
        name: dashboard.name || '',
        description: dashboard.description || '',
        code: dashboard.code || '',
      };
      setFormData(newData);
      onValidityChange(newData.name.trim() !== '' && newData.code.trim() !== '');
    }
  }, [mode, dashboard, onValidityChange]);

  useEffect(() => {
    const isValid = formData.name.trim() !== '' && formData.code.trim() !== '';
    onValidityChange(isValid);
  }, [formData.name, formData.code, onValidityChange]);

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    
    if (!formData.name.trim() || !formData.code.trim()) {
      return;
    }
    
    onSubmit({ ...formData, projectId });
  };

  useImperativeHandle(ref, () => ({
    handleSubmit
  }));

  return (
    <FormContainer>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <TextField
            fullWidth
            label="Dashboard Name"
            placeholder="Enter dashboard name"
            value={formData.name}
            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            required
          />
        </FormGroup>

        <FormGroup>
          <TextField
            fullWidth
            label="Dashboard Code"
            placeholder="Enter dashboard code"
            value={formData.code}
            onChange={(e) => setFormData(prev => ({ ...prev, code: e.target.value }))}
            required
          />
        </FormGroup>

        <FormGroup>
          <TextField
            fullWidth
            label="Description"
            placeholder="Enter dashboard description"
            value={formData.description}
            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
            multiline
            rows={4}
          />
        </FormGroup>
      </Form>
    </FormContainer>
  );
});

export default DashboardForm; 